var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpringNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "yellow-tulip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tulip"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tulip-2",
    "data-name": "tulip"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175,415.45c-32.55,0-53.92-29.65-58.57-81.32l-1.15-12.49,12.35,2.17c30.44,5.33,81.48,19.87,81.48,57.54a33.87,33.87,0,0,1-3,13.85l-5,11.29.62.6-1.08.46-.05.14-.08-.07-12.26,5.16A34,34,0,0,1,175,415.45Z",
    fill: "#a5bf8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.46,293.42C258.43,86.79,369,38.19,402.78,28.22l12.5-3.69-.18,13c-1.43,104.25-22.47,179.59-62.57,223.94-33.78,37.4-72.4,41.59-87.43,41.65l-9.8.07Z",
    fill: "#ffd58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.58,208.31c-8.2-40.26-22.08-75-41.27-103.33l-3.39-5L256.07,7l54.83,91.81-3.49,5.09c-19.59,28.53-33.72,63.66-42,104.45Z",
    fill: "#ffcecf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.88,303.16c-34.34-.12-146.64-19.69-150-265.59l-.16-13,12.5,3.69c33.81,10,144.34,58.58,147.31,265.2l.15,9.79Z",
    fill: "#ffd58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,415.45a33.81,33.81,0,0,1-13.23-2.68l-12.3-5.16-.07,0,0-.12-1.09-.46.63-.6-5-11.32a33.69,33.69,0,0,1-3-13.83c0-37.65,51-52.21,81.48-57.54l12.34-2.16-1.1,12.47c-4.6,51.7-26,81.35-58.61,81.35Z",
    fill: "#a5bf8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flower"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.37,105.22a8.27,8.27,0,0,1-7.13-12.43L248.93,4A8.26,8.26,0,0,1,256-.12h0a8.26,8.26,0,0,1,7.1,4l51.5,86.22a8.26,8.26,0,1,1-14.19,8.48L256.16,24.42l-44.64,76.69A8.26,8.26,0,0,1,204.37,105.22Z",
    fill: "#4d5152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.13,310.85c-15.92,0-48.13-3.88-79.64-30.8-52-44.44-78.35-129.9-78.35-254A8.26,8.26,0,0,1,92,19.79a8.16,8.16,0,0,1,6.61-1.92c1.65.24,165.63,27.46,165.63,284.18a8.28,8.28,0,0,1-7,8.17A69.85,69.85,0,0,1,247.13,310.85Zm8.86-8.79h0ZM105.75,36.44c1.44,111.6,26.31,191.25,72.12,230.72,28.3,24.38,56.86,27.15,69.81,27.18C245,92,138.88,45.91,105.75,36.44Z",
    fill: "#4d5152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.85,310.85a69.85,69.85,0,0,1-10.15-.62,8.28,8.28,0,0,1-7-8.17c0-133.41,44.54-203.45,81.89-238.72,41.07-38.77,82-45.21,83.76-45.46A8.27,8.27,0,0,1,422.85,26c0,124.09-26.36,209.55-78.35,254C313,307,280.78,310.85,264.85,310.85ZM256,302.06h0Zm8.32-7.72c13-.07,41.51-2.8,69.81-27.18C379.94,227.68,404.81,148,406.25,36.44,373.15,45.9,266.94,92,264.31,294.34Z",
    fill: "#4d5152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,511.88a8.27,8.27,0,0,1-8.27-8.27V250.84a8.27,8.27,0,0,1,16.54,0V503.61A8.27,8.27,0,0,1,256,511.88Z",
    fill: "#4d5152"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337,423.11a41.83,41.83,0,0,1-41.78-41.79c0-56.74,95.55-66.44,99.61-66.82a8.39,8.39,0,0,1,6.34,2.12,8.27,8.27,0,0,1,2.71,6.11C403.89,326.83,403.13,423.11,337,423.11Zm49.84-90.76c-22.15,3.79-75.08,16.3-75.08,49A25.28,25.28,0,0,0,337,406.58C376.47,406.58,385,354.39,386.85,332.36Z",
    fill: "#4d5152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.3,413.28A8.27,8.27,0,0,1,307.59,399L341,367.13a8.27,8.27,0,0,1,11.43,11.95L319,411A8.24,8.24,0,0,1,313.3,413.28Z",
    fill: "#4d5152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.49,467.54a8.27,8.27,0,0,1-5.93-14L306,400.68a8.27,8.27,0,0,1,11.86,11.53L266.41,465A8.25,8.25,0,0,1,260.49,467.54Z",
    fill: "#4d5152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,423.11c-66.12,0-66.88-96.27-66.88-100.37a8.28,8.28,0,0,1,9.05-8.23c4.06.39,99.6,10.07,99.6,66.83A41.82,41.82,0,0,1,175,423.11Zm-49.83-90.75c1.87,22,10.47,74.22,49.83,74.22a25.26,25.26,0,0,0,25.23-25.24C200.22,348.59,147.32,336.13,125.16,332.36Z",
    fill: "#4d5152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.67,413.29A8.22,8.22,0,0,1,193,411L159.6,379.08A8.27,8.27,0,0,1,171,367.13l33.36,31.92a8.27,8.27,0,0,1-5.71,14.24Z",
    fill: "#4d5152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.5,467.56a8.25,8.25,0,0,1-5.93-2.5l-51.38-52.83A8.27,8.27,0,0,1,206,400.7l51.38,52.83a8.27,8.27,0,0,1-5.93,14Z",
    fill: "#4d5152"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringNew);
export default __webpack_public_path__ + "static/media/spring-new.b254a872909080bcf5f322b22ab75f68.svg";
export { ForwardRef as ReactComponent };